// == Unichat Extension ==
// Rotas para o módulo de Setores Unichat.
// Não modifica routes nativos — importado em settings.routes.js

import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import SectorsIndex from '../views/sectors/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/unichat/sectors'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'unichat_sectors_list',
          component: SectorsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
